import styled from 'styled-components';

export const DatepickersGroup = styled.div`
  display: flex;
  gap: 8px;
`;
